export default __webpack_public_path__ + "static/media/inflo-logo-reverse.6bc2ead7.svg";